import { render, staticRenderFns } from "./link-group.vue?vue&type=template&id=afc2dd0e&scoped=true&"
import script from "./link-group.vue?vue&type=script&lang=js&"
export * from "./link-group.vue?vue&type=script&lang=js&"
import style0 from "./link-group.vue?vue&type=style&index=0&id=afc2dd0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc2dd0e",
  null
  
)

export default component.exports